




















































































































import 'reflect-metadata'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import { BlocksGettersMixin } from '@/store/modules/blocks/blocks.mixins'
import CopyText from '@/components/misc/CopyText.vue'
import Loader from '@/components/misc/Loader.vue'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK_NAME,
    HAS_SUBNET,
} from '@/store/modules/network/network'
// import { getBurnedC } from '@/services/burned/burned.service'

@Component({
    components: {
        CopyText,
        Loader,
    },
})
export default class EVMBlockRow extends Mixins(BlocksGettersMixin) {
    @Prop() blocks!: EVMBlockQueryResponse[]
    // forTSP = false
    // created() {
    //     if (
    //         window.location.href.includes('blockchain') ||
    //         localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    get isLoading() {
        return this.isFetching()
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
}
